// @flow
import { MOBILE_BREAKPOINT_WIDTH } from '@graphite/constants';
import type { TSpecsGridBreakpoint } from '@graphite/types';

export default (breakpoint: TSpecsGridBreakpoint): number => Math.max(MOBILE_BREAKPOINT_WIDTH, breakpoint.breakpoint);
